function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { colors } from '../../../abstracts/colors';
const ChevronSvg = styled.svg.withConfig({
  displayName: "ChevronSvg",
  componentId: "asurion-ui-react__sc-soc230-0"
})(["position:absolute;width:1.5rem;height:1.5rem;top:calc(50% - 0.75rem);right:1rem;pointer-events:none;"]);
export const Chevron = props => /*#__PURE__*/React.createElement(ChevronSvg, _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.41 7.99991L12 13L16.59 7.99991L18 9.40991L12 15.4099L6 9.40991L7.41 7.99991Z",
  fill: colors.black
}));